import { Component, OnInit } from '@angular/core';
import { EnvService } from '../../../../app/env.service';

@Component({
  selector: 'app-maintenance-mode',
  templateUrl: './maintenance-mode.component.html',
  styleUrls: ['./maintenance-mode.component.scss'],
  standalone: false,
})
export class MaintenanceModeComponent implements OnInit {
  tncAppVersionData: any;
  tncText: any;
  height: any;
  bgUrl: any;
  constructor(private envService: EnvService) {}

  ngOnInit() {
    this.bgUrl = 'assets/cdn/images/pyramid.png';
  }
}
